import { render, staticRenderFns } from "./EnquirySubmitted.vue?vue&type=template&id=7fafa8fb"
import script from "./EnquirySubmitted.vue?vue&type=script&lang=ts"
export * from "./EnquirySubmitted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports